<template>
  <div v-if="installments && installments.length" class="mt3">
    <div class="flex flex-wrap installment-options">
      <label
        class="flex-1 p2 pointer white-bg border-select installment-card"
        :class="{ 'border-black': selectedInternalPayment === 'sharegroop', 'red-bd': showNotSelectedError }"
      >
        <div class="flex items-center">
          <input
            v-model="selectedInternalPayment"
            type="radio"
            value="sharegroop"
            name="payment-mode"
            @change="setInstallmentOption('sharegroop')"
          >
          <span class="h6 bold">Facilités de paiement classiques :</span>
        </div>
        <div class="pl3">
          <p class="h6 mt2 mb1">Modes de paiement disponibles :</p>
          <ul class="h6 m0 pl2 installment-list">
            <li>Payer l'intégralité en CB</li>
            <li>Payer en ANCV & CB</li>
            <li>Payer avec plusieurs cartes</li>
            <li>Payer à plusieurs</li>
            <li>Payer en 2 ou 3 fois sans frais</li>
          </ul>
        </div>
      </label>

      <label
        class="flex-1 p2 pointer white-bg border-select installment-card"
        :class="{ 'border-black': selectedInternalPayment === 'installment', 'red-bd': showNotSelectedError }"
      >
        <div class="flex items-center">
          <input
            v-model="selectedInternalPayment"
            type="radio"
            value="installment"
            name="payment-mode"
            @change="setInstallmentOption('installment')"
          >
          <span class="h6 bold">Echelonner les paiements</span>
        </div>
        <div class="pl3 mt2">
          <InstallmentTable :installments="installments" />
          <p class="h6 bold mt2">Aujourd'hui, {{ todayDate }} : {{ formatAmount(installments[0].amount) }} €</p>
        </div>
      </label>
    </div>
    <span v-if="showNotSelectedError" class="h5 block col-12 no-box red py1">
      <i class="icon h5 mr2 red icon-stop"></i>Veuillez sélectionner un mode de paiement
    </span>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { format } from 'date-fns';
import { fr as frLocale } from 'date-fns/locale/fr';

import { useStore } from '@/store/index';
import InstallmentTable from '@/components/cart/InstallmentTable.vue';

const props = defineProps(['showNoSelectedError']);

const showNotSelectedError = computed(() => props.showNoSelectedError);

const store = useStore();

const selectedInternalPayment = ref(null);

const cartItem = computed(() => store.state.cart.items.find(item => item.workspace === store.state.siteInfo.workspace));

const installments = computed(() => cartItem.value.details[0].installments);

const todayDate = format(new Date(), 'dd MMM', { locale: frLocale });

const formatAmount = amount => (amount / 100).toFixed(2);

const emit = defineEmits(['selected-installments']);

const setInstallmentOption = value => {
  emit('selected-installments', value);
};
</script>

<style scoped>
.installment-options {
  gap: 16px;
}

.installment-card {
  min-width: 280px;
  border-radius: 8px;
  transition: border-color 0.2s;
}

.installment-list {
  line-height: 1.8;
}
</style>
